import { utilityService } from "shared/services";
import { IOpenAccountsReceivableCustomerDirect } from "financials/models";
import { ColumnsType, ROW_INDEX_COLUMN } from "shared/constants";
import { Link } from "react-router-dom";
import { IOrganization } from "organizations/models";
import { buildOrganizationSectionPath } from "shared/utils/paths";

export const getOpenAccountsReceivableCustomerDirectColumns = (organization: IOrganization | undefined): ColumnsType<IOpenAccountsReceivableCustomerDirect> =>
  [
    ROW_INDEX_COLUMN,
    {
      title: "Project",
      dataIndex: "projectName",
      render: (value, record, index) => (
        <Link to={buildOrganizationSectionPath(organization, `projects/${record.id}`)}>
          {utilityService.truncateField(value)}
        </Link>
      ),
    },
    {
      title: "Customer Deposit Amount Received",
      dataIndex: "customerDepositAmountReceived",
      render: (value, record, index) =>
        `$${utilityService.statisticsFormatter(value)}`,
    },
    {
      title: "Customer Days Aging",
      dataIndex: "customerDaysAging",
    },
    {
      title: "Final Customer Portion - Billed Date",
      dataIndex: "finalCustomerPortionBilledDate",
      render: (value, record, index) => utilityService.dateFormatter(value),
    },
    {
      title: "Final Customer Billed Amount",
      dataIndex: "finalCustomerBilledAmount",
      render: (value, record, index) =>
        `$${utilityService.statisticsFormatter(value)}`,
    },
    {
      title: "Final Customer Direct Amount Received",
      dataIndex: "finalCustomerDirectAmountReceived",
      render: (value, record, index) =>
        `$${utilityService.statisticsFormatter(value)}`,
    },
    {
      title: "Final Customer Direct Received Date",
      dataIndex: "finalCustomerDirectReceivedDate",
      render: (value, record, index) => utilityService.dateFormatter(value),
    },
    {
      title: "Total Customer Cost",
      dataIndex: "totalCustomerCost",
      render: (value, record, index) =>
        `$${utilityService.statisticsFormatter(value)}`,
    },
  ];
